module.exports = __webpack_public_path__ + "img/bg_detection@2x.76524a5d.png";